module.exports = __webpack_public_path__ + "img/DancingWithTheMountains.3ef27ca8.svg";